import { render, staticRenderFns } from "./StafferInfo.vue?vue&type=template&id=e12a0446&scoped=true&"
import script from "./StafferInfo.vue?vue&type=script&lang=js&"
export * from "./StafferInfo.vue?vue&type=script&lang=js&"
import style0 from "./StafferInfo.vue?vue&type=style&index=0&id=e12a0446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12a0446",
  null
  
)

export default component.exports